export enum AutomotiveBusinessLevel {
	ZeroToFifty = 0,
	FiftyToSeventyFive = 10,
	SeventyFiveToOneHundred = 20,
}
